

document.addEventListener('DOMContentLoaded', function() {
  const readMoreButtons = document.querySelectorAll('.read-more-btn');

  // Define handler once
  function handleReadMoreClick(e) {
    e.preventDefault();

    const articleCard = e.currentTarget.closest('.article-card');
    if (!articleCard) return;

    const excerptEl = articleCard.querySelector('.excerpt-text');
    const fullTextEl = articleCard.querySelector('.full-text');

    if (!excerptEl || !fullTextEl) return;

    if (fullTextEl.classList.contains('hidden')) {
      fullTextEl.classList.remove('hidden');
      excerptEl.classList.add('hidden');
    } else {
      fullTextEl.classList.add('hidden');
      excerptEl.classList.remove('hidden');
    }

    e.currentTarget.textContent = fullTextEl.classList.contains('hidden')
      ? 'Read more'
      : 'Read less';
  }

  // Attach handler safely
  readMoreButtons.forEach(button => {
    button.removeEventListener('click', handleReadMoreClick);
    button.addEventListener('click', handleReadMoreClick);
  });
});

